export const ACTIONS = {
  initialize: 'initialize',
  register: 'register',
  unregister: 'unregister',
  answer: 'answer',
  dial: 'dial',
  decline: 'decline',
  hangup: 'hangup',
  hold: 'hold',
  unhold: 'unhold',
  mute: 'mute',
  unmute: 'unmute',
  dtmf: 'dtmf',
  destroy: 'destroy',
  update: 'update',
  info: 'info',
  claim: 'claim'
};

export const ACTION_STATES = {
  registrationFailed: 'registration_failed',
  registered: 'registered',
  unregistered: 'unregistered',
  calling: 'calling',
  incomingCall: 'incomingcall',
  accepting: 'accepting',
  progress: 'progress',
  accepted: 'accepted',
  updatingCall: 'updatingcall',
  message: 'message',
  info: 'info',
  notify: 'notify',
  transfer: 'transfer',
  hangup: 'hangup',
  messageDelivery: 'messagedelivery',
  missedCall: 'missed_call'
};
